import { useEffect, useState, createRef, useCallback } from "react";
import {
  ForgotPassword,
  checkContactExist,
  // ForgotPassword,
  checkotpexisit,
  login,
  loginUrl,
  getConfigValues,
  getMemberRegistrationStatusByMemberId,
  WhoAmI,
  ValidateUser,
  testMethod,
} from "../../Helpers/APIEndPoints/EndPoints";
import { Button as BSButton, Modal as BSModal } from "react-bootstrap";
import OTPCountdown from "../../Components/CountDown/Countdown";
import { APICall, HttpMethod } from "../../Helpers/Network/APICalls";
import Logo from "../../Assets/Images/afcons_logo.svg.png";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setUserData, clearUserData, setSsoFromCurrentDomain } from "../../Redux/Actions";

import "./Login.css";
import { Alert, Button, Link, Typography } from "@mui/material";
import ButtonForm from "../../Components/ButtonForm/ButtonForm";
import InputForm, { AutoCompleteValue } from "../../Components/InputForm/InputForm";
import { ApiStatus } from "../../Helpers/Enums/ApiStatus";
import { CheckUserCredentialsCode, CheckUserCredentialsModel } from "../../Models/CheckUserCredentialsModel";
import notify, { ToastType } from "../../Helpers/ToastNotification";
import { GenericResponseModel } from "../../Models/GenericResponseModel";
import ComponentLoader from "../../Helpers/Loader/ComponentLoader";
import { AllRoutes } from "../../Routes/router";
import { RoleEnum } from "../../Helpers/Enums/RoleEnum";
import { getDefaultDashboard, hasOnlyDigits } from "../../Helpers/Common";
import moment from "moment";
import { DeleteMemberIdFromLocalStorage, SetEncryptedMemberIdToLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
import { getContext } from "../../Helpers/Context/Context";
import * as _ from "lodash";
import { decryptV2, encryptV2 } from "../../Helpers/Cryptography/CryptoV2";
import Modal from "react-modal";
import ButtonComponent from "../../Components/ButtonForm/Button";
import SSONotRegistered from "./SSONotRegistered";
// import { Alert } from "react-bootstrap";
let mobile = "";

const Login = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  //const [searchParams, setSearchParams] = useSearchParams();
  // let user = "testuser1@mahindra.com";
  // let pass = "Abc@123";

  let searchParams = new URLSearchParams(window.location.search);

  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [mobileNumber, setMobileNumber] = useState<string>("");
  const [activeTab, setActiveTab] = useState<number>(1);
  const [forgotPasswordClicked, setForgotPasswordClicked] = useState<boolean>(false);
  const [forgotPasswordMessage, setForgotPasswordMessage] = useState<string>("");
  const [showLoader, setShowLoader] = useState<boolean>(false);
  const [showCountdown, setShowCountdown] = useState(false);
  const [otpcount, setOtpCount] = useState(0);
  // const [disabledResend, setDisabledReset] = useState(true);
  //const [otperror, setError] = useState("");
  const [attemptsMinute, setAttemptsminute] = useState([]);
  // const [remainingTime, setRemainingTime] = useState(2);
  const otpBox1 = createRef<HTMLInputElement>();
  const otpBox2 = createRef<HTMLInputElement>();
  const otpBox3 = createRef<HTMLInputElement>();
  const otpBox4 = createRef<HTMLInputElement>();
  const otpBox5 = createRef<HTMLInputElement>();
  const otpBox6 = createRef<HTMLInputElement>();
  const [otp, setOtp] = useState({
    first: "",
    second: "",
    third: "",
    fourth: "",
    fifth: "",
    sixth: "",
  });
  const onChange = (key, value) => {
    setOtp({ ...otp, [key]: value });
    switch (key) {
      case "first":
        otpBox2.current?.focus();
        break;
      case "second":
        otpBox3.current?.focus();
        break;
      case "third":
        otpBox4.current?.focus();
        break;
      case "fourth":
        otpBox5.current?.focus();
        break;
      case "fifth":
        otpBox6.current?.focus();
        break;
      case "sixth":
        break;
    }
  };
  enum ButtonClickTarget {
    CoreUsersSSO,
    OtherUsersSubmit,
    CheckAppStatusSubmit,
    SendOtp,
    ResendOtp,
    ForgotPassword,
    NewRegistrationClick,
  }

  const onButtonClick = (target: ButtonClickTarget) => {
    switch (target) {
      case ButtonClickTarget.CoreUsersSSO:
        ssoClickHandler();
        break;
      case ButtonClickTarget.OtherUsersSubmit:
        submitUserCreds();
        break;
      case ButtonClickTarget.CheckAppStatusSubmit:
        verifyOtp();
        break;
      case ButtonClickTarget.SendOtp:
        SendOtp();
        break;
      case ButtonClickTarget.ResendOtp:
        SendOtp();
        break;
      case ButtonClickTarget.ForgotPassword:
        submitForgotPassword();
        break;
      case ButtonClickTarget.NewRegistrationClick:
        DeleteMemberIdFromLocalStorage();
        navigate(AllRoutes.MemberRegistrationForm.link);
        break;
    }
  };
  const handleCountdownComplete = () => {
    setShowCountdown(false);
    // setDisabledReset(false);
  };

  const afterLogin = (resp) => {
    if (resp.Status === ApiStatus.OK) 
      {
      if (resp.Data) {
        const loginResp = resp.Data as CheckUserCredentialsModel;
        if (loginResp.Status && loginResp.Code === CheckUserCredentialsCode.SuccessfulLogin) {
          if (loginResp?.UserDetails?.Roles?.[0]) {
            const combinedObject = {
              ...loginResp?.UserDetails,
              ...{ loggedInAs: loginResp.UserDetails.Roles[0] },
            };

            try {
              if (!combinedObject?.UnitCodeId) {
                if (combinedObject?.["UnitCodeIds"]) {
                  const ucs = combinedObject?.["UnitCodeIds"]?.split(",");
                  if (ucs?.length > 0) {
                    combinedObject.UnitCodeId = ucs[0];
                  }
                }
              }
              if (!combinedObject?.UnitCodeIds) {
                combinedObject.UnitCodeIds = combinedObject?.Roles?.map((r) => r?.["UnitCodes"]).join(",");
                combinedObject.UnitCodeId = combinedObject.UnitCodeIds?.split(",")?.[0];
              }
            } catch (err) {}

            let userData = combinedObject;

            //let userData = loginResp?.UserDetails;
            dispatch(setUserData(userData));

            if (location.search) {
              const params = new URLSearchParams(location.search);
              if (params.has("memberid")) {
                navigate(AllRoutes.MemberVerificationView.link + "?memberid=" + params.get("memberid"));
                return;
              } else if (params.has("suretyid")) {
                navigate(AllRoutes.SuretyApproval.link + "?suretyid=" + params.get("suretyid"));
                return;
              } else if (params.has("docid")) {
                navigate(AllRoutes.DownloadDoc.link + "?docid=" + params.get("docid"));
                return;
              }
            }
            let page = getDefaultDashboard(userData.loggedInAs.RoleId);
            navigate(page, { state: 0 });
          } else {
            notify(ToastType.Error, "You don't have access, please contact Administrator");
          }
        } else {
          notify(ToastType.Error, loginResp.Message);
        }
      }
    }else if(resp.Status === ApiStatus.UserNotPresent)
      {
      notify(ToastType.Error, resp.Message);
    }
     else {
      notify(ToastType.Error, resp.Message);
    }
  };

  const submitUserCreds = async () => {
    if (!username || !password) {
      notify(ToastType.Error, "Please fill username & password fields.");
      return;
    }
    setShowLoader(true);
    try {
      const resp = await APICall(login, {
        username: username,
        password: password,
      });

      afterLogin(resp);
    } catch (err) {
    } finally {
      setShowLoader(false);
    }
  };

  const submitForgotPassword = async () => {
    setShowLoader(true);
    try {
      const resp = await APICall(ForgotPassword, {
        LoginId: username,
      });

      if (resp.Status === ApiStatus.OK) {
        if (resp.Data) {
          const loginResp = resp.Data as GenericResponseModel;

          if (loginResp.Status) {
            //notify(ToastType.Success, loginResp.Message);
            setForgotPasswordMessage(loginResp.Message);
          } else {
            notify(ToastType.Error, loginResp.Message);
          }
        }
      } else {
        notify(ToastType.Error, resp.Message);
      }
    } catch (err) {
    } finally {
      setShowLoader(false);
    }
  };

  const ssoClickHandler = useCallback(async () => {
    let timer = null;
    setShowLoader(true);
    try {
      //dispatch(setSsoFromCurrentDomain(true));
      localStorage.setItem("ssoFromCurrentDomain", encryptV2("true"));
      const resp = await APICall(ValidateUser, null);
      if (resp?.Status === ApiStatus.OK && resp?.Data) {
       
        window.location.href = resp?.Data;
      }
    } catch (err) {
    } finally {
      timer = setTimeout(() => {
        setShowLoader(false);
      }, 5000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, []);

  const verifySSO = async (ssoToken) => {
    setShowLoader(true);
    try {
      const resp = await APICall(WhoAmI, {
        UserData: ssoToken,
      });
      afterLogin(resp);
    } catch (err) {
    } finally {
      setShowLoader(false);
    }
  };

  useEffect(() => {
    setForgotPasswordClicked(false);
  }, [activeTab]);
  useEffect(() => {
    const REACT_APP_TEST_ENV_VAR = process.env.REACT_APP_TEST_ENV_VAR;
    

    //for (let index = 0; index < 1000; index++) {
    Config();
    //}

    //check if user is already logged in
    let ctx = getContext();
    if (ctx && ctx?.Id) {
      let page = getDefaultDashboard(ctx.CurrentRoleId);
      navigate(page, { state: 0 });
    }
  }, []);
  useEffect(() => {
    //console.info(`searchParams : ${JSON.stringify(searchParams)}`);
    if (typeof URLSearchParams === "undefined") {
      console.info(`Your browser ${navigator.appVersion} does not support URLSearchParams`);
      return;
    }
    searchParams = new URLSearchParams(window.location.search);

    //if (searchParams.size > 0) {
    if (searchParams.has("user")) {
      const ssoUserData = searchParams.get("user");
      if (ssoUserData) {
        verifySSO(encodeURIComponent(ssoUserData));
        searchParams.delete("user");
        //setSearchParams(searchParams);
      }
    }
    //}
  }, [window.location.search]);

  useEffect(() => {
    if (location.hash) {
      let tabName = location.hash?.split("#")?.[1];
      if (tabName) {
        switch (tabName) {
          case "core":
            setActiveTab(0);
            break;
          default:
          case "other":
            setActiveTab(1);
            break;
          case "appStatus":
            setActiveTab(2);
            break;
        }
      }
    }
  }, [location.hash]);

  // useEffect(() => {
  //   const interval = setTimeout(() => {
  //     setShowLoader(!showLoader);
  //   }, 5000);

  //   return () => clearTimeout(interval);
  // }, [showLoader]);

  const Config = async () => {
    let temp = [];
    let arr = ["attempts", "otpminute"];
    //  arr.map(async (d) => {
    // let val = `${configValue}/${d}`;
    const configdata = await APICall(getConfigValues, { Keys: arr });
    if (configdata?.Status === ApiStatus.OK) {
      temp = configdata?.Data ? configdata?.Data?.map((c) => Number(c?.Value)) : [];
     
      setAttemptsminute(temp);
      // setRemainingTime(temp.length > 0 && temp[1].d)
    }
  };
 
  const SendOtp = async () => {
    setShowLoader(true);
    //setError("");
    //   setDisabledReset(true);
    //

    setOtpCount(otpcount + 1);
    const resp = await APICall(checkContactExist, {
      ContactNo: mobileNumber,
      Otpcount: otpcount + 1,
      OtpDate: moment().format("YYYY-MM-DD"),
      otpattempts: attemptsMinute[0],
    });
   
    if (resp.Data.Data != null) {
      // alert(resp.Data.Data)
      setShowCountdown(true);
      notify(ToastType.Success, "OTP sent successfully, please enter OTP received on your mobile number.");
    } else {
      setShowCountdown(false);
      //setError(resp.Data.Message);
      notify(1, resp.Data.Message);
    }
    // else {
    //   setError("No more attempts left for the day");
    // }
    setShowLoader(false);
  };
  const verifyOtp = async () => {
    let otpconvert = `${otp.first}${otp.second}${otp.third}${otp.fourth}${otp.fifth}${otp.sixth}`;
   
    let obj = {
      User_Otp: otpconvert,
      ContactNo: mobileNumber,
    };
    const otpcheck = await APICall(checkotpexisit, obj);
    
    if (otpcheck.Data?.Data && otpcheck.Data?.Data?.Id != null && otpcheck.Data?.Data?.Id != 0) {
      setShowCountdown(false);
      setMobileNumber("");
      setOtp({
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: "",
      });
      let obj = { MemberId: otpcheck.Data.Data.Id };
      const registrationStatus = await APICall(getMemberRegistrationStatusByMemberId, obj);
      
      SetEncryptedMemberIdToLocalStorage(otpcheck.Data.Data.Id.toString());
      navigate("/MemberRegistrationForm", {
        state: {
          MemberId: otpcheck.Data.Data.Id,
          StatusId: registrationStatus.Data.StatusId,
          IsMemberPersonalDetail: registrationStatus.Data.IsMemberPersonalDetailsExists,
          IsMemberEmployementDetail: registrationStatus.Data.IsMemberEmploymentDetailsExists,
          IsMemberWitnessDetail: registrationStatus.Data.IsMemberWitnessDetailsExists,
          IsMemberNomineeDetail: registrationStatus.Data.IsMemberWitnessDetailsExists,
          StatusName: registrationStatus.Data.StatusName,
        },
      });
    } else {
      setShowCountdown(false);
      // setDisabledReset(false);
      setOtp({
        first: "",
        second: "",
        third: "",
        fourth: "",
        fifth: "",
        sixth: "",
      });
      //setError(otpcheck.Data.Data?.[0].OtpError || "Invalid OTP");
      notify(ToastType.Error, otpcheck.Data.Data?.[0]?.OtpError || "Invalid OTP");
    }
  };
  const pasteOtp = (event: React.ClipboardEvent<HTMLInputElement>) => {
    event.preventDefault();
    const value = (event.clipboardData || window["clipboardData"]).getData("text");
    if (hasOnlyDigits(value) && value?.toString()?.length === 6) {
      setOtp({
        first: value?.[0] || "",
        second: value?.[1] || "",
        third: value?.[2] || "",
        fourth: value?.[3] || "",
        fifth: value?.[4] || "",
        sixth: value?.[5] || "",
      });
    }
  };

  const testBuildMethod6 = () => {
   
  };

  if (searchParams.has("error")) {
    return <SSONotRegistered />;
  }

  return (
    <div className="login_wrapper">
      <div className="_20241224_110856" />
      <div className="container-fluid">
        <div className="row">
          <div className="col-lg-6 p-0">
            <div className="login_left_bg">
              <div className="left_bg_inner text-center">
                <img src="images/mahindra_logo.jpg" alt="Mahindra Logo" />
              </div>
            </div>
          </div>

          <div className="col-lg-6 p-0">
            <div className="login_right_bg">
              <div className="right_bg_inner">
                <div className="text-center">
                  <img src="images/Logo.png" alt="Pride Logo" />
                  <div>
                    <b>Welcome to Mahindra Credit Society</b>
                  </div>
                </div>
                <ComponentLoader show={showLoader}>
                  {/* <!-- Nav tabs --> */}
                  <ul className="nav nav-tabs">
                    <li className="nav-item" onClick={() => setActiveTab(0)}>
                      <a className={"nav-link " + (activeTab === 0 ? "active" : "")} data-toggle="tab" href="login#core">
                        Officers, M&M and Core Users
                      </a>
                    </li>
                    <li className="nav-item" onClick={() => setActiveTab(1)}>
                      <a className={"nav-link " + (activeTab === 1 ? "active" : "")} data-toggle="tab" href="login#other">
                        Associates & Others
                      </a>
                    </li>
                    <li className="nav-item" onClick={() => setActiveTab(2)}>
                      <a className={"nav-link " + (activeTab === 2 ? "active" : "")} data-toggle="tab" href="login#appStatus">
                        Check Application Status
                      </a>
                    </li>
                  </ul>

                  {/* <!-- Tab panes --> */}
                  <div className="tab-content">
                    {activeTab === 0 && (
                      <div className={"tab-pane " + (activeTab === 0 ? "active" : "fade")} id="core">
                        <div className="sso-container">
                          <div className="sso-icon-container">
                            <i className="fa fa-unlock sso-icon"></i>
                          </div>
                          <a className="sso-button" onClick={() => onButtonClick(ButtonClickTarget.CoreUsersSSO)}>
                            Login with SSO
                          </a>
                        </div>
                        <div className="mt-2 text-center member-btn d-none">
                          <a
                            href={AllRoutes.MemberRegistrationForm.link}
                            onClick={(event) => {
                              event.preventDefault();
                              onButtonClick(ButtonClickTarget.NewRegistrationClick);
                            }}
                          >
                            If you are not a member <span className="click-here">Click here</span> to register to the society
                          </a>
                        </div>
                      </div>
                    )}
                    {activeTab === 1 && (
                      <div className={"tab-pane " + (activeTab === 1 ? "active" : "fade")} id="other">
                        <div className="form_grid">
                          <div className="form-group">
                            {/* <!-- <label>Email ID</label> --> */}
                            <div className="input_grid">
                              <input
                                autoComplete={AutoCompleteValue}
                                type="text"
                                name="email"
                                placeholder={forgotPasswordClicked ? "Enter your email id" : "Enter ID"}
                                className="form-control"
                                onChange={(event) => setUsername(event.target.value)}
                              />
                              <i className="fa fa-envelope"></i>
                            </div>
                          </div>
                          {!forgotPasswordClicked && (
                            <div className="form-group">
                              {/* <!-- <label>Password</label> --> */}
                              <div className="input_grid">
                                <input
                                  autoComplete={AutoCompleteValue}
                                  type="password"
                                  name=""
                                  placeholder="••••••••"
                                  className="form-control"
                                  onChange={(event) => setPassword(event.target.value)}
                                />
                                <i className="fa fa-lock"></i>
                              </div>
                            </div>
                          )}
                          {forgotPasswordClicked && forgotPasswordMessage && (
                            <Alert severity="success" variant="filled" onClose={() => setForgotPasswordMessage("")}>
                              <p>{forgotPasswordMessage}</p>
                            </Alert>
                          )}
                          {!forgotPasswordClicked && (
                            <div className="forgot_pass text-right">
                              <Link onClick={() => setForgotPasswordClicked(true)}>Forgot Password ?</Link>
                            </div>
                          )}
                          <div className="text-center">
                            <button
                              className="btn btn-signUp"
                              onClick={() => onButtonClick(forgotPasswordClicked ? ButtonClickTarget.ForgotPassword : ButtonClickTarget.OtherUsersSubmit)}
                            >
                              Submit
                            </button>
                          </div>
                          {/* #region NOT IN USE */}
                          <div className="mt-2 text-center member-btn">
                            <Link
                              href={AllRoutes.MemberRegistrationForm.link}
                              onClick={(event) => {
                                event.preventDefault();
                                onButtonClick(ButtonClickTarget.NewRegistrationClick);
                              }}
                            >
                              If you are not a member <span className="click-here">Click here</span> to register to the society
                            </Link>
                          </div>
                          {/* #endregion */}
                        </div>
                      </div>
                    )}
                    {activeTab === 2 && (
                      <div className={"tab-pane " + (activeTab === 2 ? "active" : "fade")} id="appStatus">
                        <div className="form_grid">
                          <div className="form-group col-lg-12 row mx-0 p-0 align-items-center">
                            <div className="input_grid pl-0 col-lg-9 col-md-9 col-sm-9 col-9">
                              <input
                                autoComplete={AutoCompleteValue}
                                type="text"
                                name="mobilenumber"
                                maxLength={10}
                                placeholder="Mobile No."
                                className="form-control mobile-inp"
                                onChange={(e) => setMobileNumber(e.target.value)}
                                value={mobileNumber}
                              />
                              <i style={{ fontSize: "15px" }} className="fa-solid fa-mobile-screen-button mx-3 my-1"></i>
                            </div>
                            <div className="col-lg-3 col-md-3 col-sm-3 col-3 p-0" style={{ padding: "0 0 0 14px !important" }}>
                              <button className="btn btn-otp" onClick={() => onButtonClick(ButtonClickTarget.SendOtp)}>
                                <i className="fas fa-arrow-right mx-3 my-1"></i>
                                Send OTP
                              </button>
                            </div>
                          </div>
                          {showCountdown && (
                            <div>
                              <div className="form-group">
                                <div className="input_grid">
                                  <div className="userInput">
                                    <input
                                      autoComplete={AutoCompleteValue}
                                      ref={otpBox1}
                                      className="otp-boxes"
                                      type="text"
                                      id="ist"
                                      maxLength={1}
                                      value={otp.first}
                                      onChange={(e) => onChange("first", e.target.value)}
                                      onPaste={(e: React.ClipboardEvent<HTMLInputElement>) => pasteOtp(e)}
                                    />
                                    <input
                                      autoComplete={AutoCompleteValue}
                                      ref={otpBox2}
                                      className="otp-boxes"
                                      type="text"
                                      id="sec"
                                      maxLength={1}
                                      value={otp.second}
                                      onChange={(e) => onChange("second", e.target.value)}
                                    />
                                    <input
                                      autoComplete={AutoCompleteValue}
                                      ref={otpBox3}
                                      className="otp-boxes"
                                      type="text"
                                      id="third"
                                      maxLength={1}
                                      value={otp.third}
                                      onChange={(e) => onChange("third", e.target.value)}
                                    />
                                    <input
                                      autoComplete={AutoCompleteValue}
                                      ref={otpBox4}
                                      className="otp-boxes"
                                      type="text"
                                      id="fourth"
                                      maxLength={1}
                                      value={otp.fourth}
                                      onChange={(e) => onChange("fourth", e.target.value)}
                                    />
                                    <input
                                      autoComplete={AutoCompleteValue}
                                      ref={otpBox5}
                                      className="otp-boxes"
                                      type="text"
                                      id="fifth"
                                      maxLength={1}
                                      value={otp.fifth}
                                      onChange={(e) => onChange("fifth", e.target.value)}
                                    />
                                    <input
                                      autoComplete={AutoCompleteValue}
                                      ref={otpBox6}
                                      className="otp-boxes"
                                      type="text"
                                      id="fifth"
                                      maxLength={1}
                                      value={otp.sixth}
                                      onChange={(e) => onChange("sixth", e.target.value)}
                                    />
                                  </div>
                                </div>
                              </div>
                              <div style={{ textAlign: "center" }}>
                                {/* {showCountdown === true && (
                              <OTPCountdown
                                min={
                                  attemptsMinute.length > 0
                                    ? attemptsMinute[1]
                                    : ""
                                }
                                onComplete={handleCountdownComplete}
                              />
                            )} */}
                                {/* {<span>{otperror}</span>} */}
                              </div>
                              <div className="resend-otp text-center">
                                <a
                                  href="javascript:void(0);"
                                  onClick={() => onButtonClick(ButtonClickTarget.ResendOtp)}
                                  // style={
                                  //   disabledResend === true
                                  //     ? {
                                  //         cursor: "not-allowed",
                                  //         pointerEvents: "none",
                                  //         color: "grey",
                                  //       }
                                  //     : {}
                                  // }
                                >
                                  Resend OTP
                                </a>
                              </div>
                            </div>
                          )}
                          <div className="text-center">
                            <button className="btn btn-signUp" disabled={!showCountdown} onClick={() => onButtonClick(ButtonClickTarget.CheckAppStatusSubmit)}>
                              Submit
                            </button>
                          </div>
                          {/* <div className="mt-2 text-center member-btn">
                            <a href="javascript:void(0);">
                              If you are not a member{" "}
                              <span className="click-here">Click here</span> to
                              register to the society
                            </a>
                          </div> */}
                        </div>
                      </div>
                    )}
                  </div>
                </ComponentLoader>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
